export const SHOW_MENU = "SHOW_MENU";
export const HIDE_MENU = "HIDE_MENU";
